var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, IconButton } from "@mui/material";
import { UINumberField } from "../ui-number-field";
var btnStyle = {
    p: 0,
    opacity: 0.4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
var UIQuantityInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, onIncrease = _a.onIncrease, onDecrease = _a.onDecrease, sx = _a.sx;
    return (_jsxs(Box, { sx: __assign({ display: "inline-flex", alignItems: "center", width: 105, flexShrink: 0, flexDirection: "row", gap: "4px", px: "8px", border: "1px solid rgb(38 39 45)", borderRadius: "6px", "@media (max-width:750px)": { height: "40px" } }, sx), children: [_jsx(Box, { className: "minuce", display: "flex", alignItems: "center", justifyContent: "center", children: _jsx(IconButton, { "aria-label": "", sx: btnStyle, onClick: onDecrease, disabled: value <= 0, children: _jsx(RemoveIcon, { sx: { color: "#fff" } }) }) }), _jsx(Box, { className: "numberInput", children: _jsx(UINumberField, { value: value.toString(), onChange: function (val) {
                        var num = val ? parseInt(val, 10) : 0;
                        onChange(num);
                    }, placeholder: "0", sx: {
                        border: 0,
                        bgcolor: "transparent",
                        outline: "none",
                        fontSize: { xs: "0.875rem", md: "1rem" },
                        textAlign: "center",
                        p: 0,
                    }, sxInput: { textAlign: "center", p: 0 } }) }), _jsx(Box, { className: "plus", display: "flex", alignItems: "center", justifyContent: "center", children: _jsx(IconButton, { sx: btnStyle, "aria-label": "", onClick: onIncrease, children: _jsx(AddIcon, { sx: { color: "#fff" } }) }) })] }));
};
export default UIQuantityInput;
